import { NestedFilterInput, Product } from '@@types'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router'
import { useMediaQuery } from 'usehooks-ts'

import stylesLayout from '@pages/catalog/ui/styles.module.scss'

import { useFetchAllProducts } from '@entities/Product'

import { CartPreview } from '@features/cart'
import { useAddressStore } from '@features/shipping-methods'

import { CategoriesSidebar } from '@widgets/categories-branch'
import ProductsInfiniteScroll from '@widgets/products-infinite-scroll'

import { IMAGE_SIZES, URL_PAGE_CATALOG } from '@shared/contants'
import { cn } from '@shared/lib/cn'
import Breadcrumbs from '@shared/ui/breadcrumbs'
import Container from '@shared/ui/container'
import PageGrid from '@shared/ui/page-grid'
import TitleWithCount from '@shared/ui/title-with-count'
import Wrapper from '@shared/ui/wrapper'
import getNoun from '@shared/uttils/getNoun'

import styles from './styles.module.scss'

function parseFilter (raw: string | null): NestedFilterInput | undefined {
  if (!raw) return undefined
  try {
    return JSON.parse(raw) as NestedFilterInput
  }
  catch {
    return undefined
  }
}

export default function ProductFilterProductsPage () {
  const { t: tn } = useTranslation('navigation')
  const { t: tp } = useTranslation('product')
  const isTablet = useMediaQuery('(max-width: 991px)')
  const { shopId } = useAddressStore()
  const [ searchParams ] = useSearchParams()

  const filter = parseFilter(searchParams.get('filter'))
  const label = searchParams.get('label') ?? ''

  const {
    products,
    pageInfo,
    loading,
    fetchNextPage,
    hasMore,
  } = useFetchAllProducts({
    filter,
    sort: {
      fieldName: 'preview_id',
      direction: 1,
    },
    shop_id: shopId,
    style: IMAGE_SIZES.LARGE,
  }, !filter)

  const totalProducts = pageInfo?.lastPage && pageInfo?.perPage
    ? pageInfo.lastPage * pageInfo.perPage
    : products.length

  return (
    <Container>
      <PageGrid aside={<CartPreview />}>
        <Wrapper className={styles.wrapper}>
          <div className={stylesLayout.grid}>
            <Breadcrumbs
              className={stylesLayout.breadcrumbs}
              links={[
                {
                  title: tn('catalog'),
                  to: URL_PAGE_CATALOG,
                },
                {
                  title: label,
                },
              ]}
            />
            {!isTablet && (
              <div className={cn(stylesLayout.aside, styles.aside)}>
                <div className={styles.aside}>
                  <CategoriesSidebar className={styles.aside__content} />
                </div>
              </div>
            )}
            <div className={cn(stylesLayout.content)}>
              <div className={styles.root__top}>
                <TitleWithCount
                  className={styles.root__title}
                  title={label}
                >
                  {totalProducts !== null && (
                    <>
                      {totalProducts}{' '}
                      {getNoun(
                        totalProducts,
                        tp('product.1'),
                        tp('product.2'),
                        tp('product.3'),
                      )}
                    </>
                  )}
                </TitleWithCount>
              </div>
              <ProductsInfiniteScroll
                products={products as Product[]}
                loading={loading}
                fetchNextPage={fetchNextPage}
                hasMore={hasMore}
              />
            </div>
          </div>
        </Wrapper>
      </PageGrid>
    </Container>
  )
}
